import React from "react";
import { Navigate, RouteObject } from "react-router-dom";
import { AuthLayout } from "@/shared/ui/layouts/AuthLayout";

export const authRoutes: RouteObject[] = [
{
    path: "/auth",
    element: <AuthLayout />,
    children: [
      {
        path: "login",
        lazy: () =>
          import("@/features/auth/pages/LoginPage").then((m) => ({ Component: m.LoginPage })),
      },
      {
        path: "oauth",
        lazy: () =>
          import("@/features/auth/pages/OAuthCallbackPage").then((m) => ({ Component: m.OAuthCallbackPage })),
      },
      {
        path: "oidc",
        lazy: () =>
          import("@/features/auth/pages/OIDCCallbackPage").then((m) => ({ Component: m.OIDCCallbackPage })),
      },
      {
        path: "saml",
        lazy: () =>
          import("@/features/auth/pages/SAMLCallbackPage").then((m) => ({ Component: m.SAMLCallbackPage })),
      },
      {
        path: "forgot-password",
        lazy: () =>
          import("@/features/auth/pages/ForgotPasswordPage").then((m) => ({ Component: m.ForgotPasswordPage })),
      },
      {
        path: "reset-password",
        lazy: () =>
          import("@/features/auth/pages/ResetPasswordPage").then((m) => ({ Component: m.ResetPasswordPage })),
      },
      {
        path: "signup",
        lazy: () =>
          import("@/features/auth/pages/SignupPage").then((m) => ({ Component: m.SignupPage })),
      },
      {
        path: "verify-email",
        lazy: () =>
          import("@/features/auth/pages/VerifyEmailPage").then((m) => ({ Component: m.VerifyEmailPage })),
      },
      {
        path: "waiting-on-verification",
        lazy: () =>
          import("@/features/auth/pages/WaitingVerificationPage").then((m) => ({
            Component: m.WaitingVerificationPage,
          })),
      },
      { index: true, element: <Navigate to="login" replace /> },
    ],
  }
];
